import { render } from "./NewsGrid.vue?vue&type=template&id=714a7f79&scoped=true"
import script from "./NewsGrid.vue?vue&type=script&lang=js"
export * from "./NewsGrid.vue?vue&type=script&lang=js"

import "./NewsGrid.vue?vue&type=style&index=0&id=714a7f79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714a7f79"]])

export default __exports__